import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  ViewChild
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[appEllipsisTooltips]',
  providers: [MatTooltip]
})
export class EllipsisTooltipsDirective implements AfterViewInit {
  // The child of the element has directive
  @ViewChild('templateRefName') el!: ElementRef;
  // The value of the tooltip for showing
  @Input() public ellipsisTooltipsValue!: string;
  // The custom class for the tooltip
  @Input() public set tooltipClassNames(customTooltip: string) {
    this.tooltip.tooltipClass = customTooltip;
  }
  // The maximum line for the content
  @Input() public lineClamp: number = 1;
  // The position of the tooltip
  @Input() public set tooltipPosition(
    val: 'left' | 'right' | 'above' | 'below' | 'before' | 'after'
  ) {
    if (this.tooltip) {
      this.tooltip.position = val;
    }
  }

  // The MatTooltip controller
  public tooltip!: MatTooltip;

  // The renderer controller
  public renderer!: Renderer2;

  public constructor(
    private _tooltip: MatTooltip,
    private elementRef: ElementRef,
    private _renderer: Renderer2
  ) {
    this.tooltip = this._tooltip;
    // Set default tooltip position is bellow
    this.tooltip.position = 'below';
    // Set controller for elementRef
    this.elementRef = this.el || this.elementRef;
    // Set controller for renderer
    this.renderer = this._renderer;
  }

  ngAfterViewInit() {
    // Set style for element
    this.renderer.setStyle(
      this.elementRef.nativeElement,
      '-webkit-line-clamp',
      this.lineClamp
    );
    // Add class for element
    this.renderer.addClass(this.elementRef.nativeElement, 'text-ellipsis');
  }

  /**
   * Function tracking the mouse over on the content
   * Then checking if showing the tooltip or not
   */
  @HostListener('mouseover') mouseover() {
    const element = this.elementRef.nativeElement;
    this.tooltip.message = this.ellipsisTooltipsValue;
    if (element.offsetWidth < element.scrollWidth) {
      this.tooltip.show();
    }
  }

  /**
   * Function tracking the mouse leave from the content
   */
  @HostListener('mouseleave') mouseleave() {
    this.tooltip.message = '';
    this.tooltip.hide();
  }
}
